export function companyTierToMaxUsers(companyTier) {
  let maxUsers = 0;
  switch (companyTier) {
    case 1:
      maxUsers = 5;
      break;
    case 2:
      maxUsers = 5;
      break;
    default:
      maxUsers = 0;
  }
  return maxUsers;
}